import { Nullable } from 'types';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type IsGalleryModalVisible = boolean;
type IsLoad = boolean;

export enum ImageCreatedBy {
    AiMidjourney = 'AI_MIDJOURNEY',
    AiStableDiffusion = 'AI_STABLE_DIFFUSION',
    AiFlux = 'AI_FLUX',
}

export interface Image {
    cropImageUrl: string;
    originalImageId: number;
    originalImageWidth: number;
    originalImageHeight: number;
    previewUrl: string;
    createdBy: Nullable<ImageCreatedBy>;
}

export interface DefaultImageWithProfRole {
    defaultImagesDto: Image[];
    profRoleName: string;
}

// ----------------------- actions -------------------------------------
const SET_USER_LOADED_IMAGES = 'SET_USER_LOADED_IMAGES';
const SET_DEFAULT_IMAGES = 'SET_DEFAULT_IMAGES';
const SET_IS_LOAD_GALLERY_IMAGES = 'SET_IS_LOAD_GALLERY_IMAGES';
const SET_IS_GALLERY_MODAL_VISIBLE = 'SET_IS_GALLERY_MODAL_VISIBLE';
const SET_IS_AI_IMAGE_GENERATION_MODAL_OPENED_FROM_GALLERY_MODAL =
    'SET_IS_AI_IMAGE_GENERATION_MODAL_OPENED_FROM_GALLERY_MODAL';

interface PayloadTypes {
    [SET_USER_LOADED_IMAGES]: Image[];
    [SET_DEFAULT_IMAGES]: DefaultImageWithProfRole[];
    [SET_IS_LOAD_GALLERY_IMAGES]: IsLoad;
    [SET_IS_GALLERY_MODAL_VISIBLE]: IsGalleryModalVisible;
    [SET_IS_AI_IMAGE_GENERATION_MODAL_OPENED_FROM_GALLERY_MODAL]: boolean;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setUserLoadedImages = ActionCreator(SET_USER_LOADED_IMAGES);
export const setDefaultImages = ActionCreator(SET_DEFAULT_IMAGES);
export const setLoadGalleryImages = ActionCreator(SET_IS_LOAD_GALLERY_IMAGES);
export const setIsGalleryModalVisible = ActionCreator(SET_IS_GALLERY_MODAL_VISIBLE);
export const setIsAiImageGenerationModalOpenedFromGalleryModal = ActionCreator(
    SET_IS_AI_IMAGE_GENERATION_MODAL_OPENED_FROM_GALLERY_MODAL
);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface GalleryState {
    userLoadedImages: Image[];
    defaultImages: DefaultImageWithProfRole[];
    isLoad: IsLoad;
    isGalleryModalVisible: IsGalleryModalVisible;
    isAiImageGenerationModalOpenedFromGalleryModal: boolean;
}

export const GALLERY_INITIAL_STATE: GalleryState = {
    userLoadedImages: [],
    defaultImages: [],
    isLoad: false,
    isGalleryModalVisible: false,
    isAiImageGenerationModalOpenedFromGalleryModal: false,
};

export default createReducer<GalleryState, PayloadTypes>(GALLERY_INITIAL_STATE, {
    [SET_USER_LOADED_IMAGES]: (state, { payload }) => ({
        ...state,
        userLoadedImages: payload,
    }),
    [SET_DEFAULT_IMAGES]: (state, { payload }) => ({
        ...state,
        defaultImages: payload,
    }),
    [SET_IS_LOAD_GALLERY_IMAGES]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
    [SET_IS_GALLERY_MODAL_VISIBLE]: (state, { payload }) => ({
        ...state,
        isGalleryModalVisible: payload,
    }),
    [SET_IS_AI_IMAGE_GENERATION_MODAL_OPENED_FROM_GALLERY_MODAL]: (state, { payload }) => ({
        ...state,
        isAiImageGenerationModalOpenedFromGalleryModal: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
